import { useEffect, useState } from "react";
import { useLocalStorage, useWindowSize } from "usehooks-ts";
import { useGeoSearch } from "./use-geosearch";
export function useToggleMap({
  initiallyOpen = true
}: {
  initiallyOpen: boolean;
}) {
  const [hasMounted, setHasMounted] = useState(false);
  const [showMapAnimation, setShowMapAnimation] = useState(false);
  const [animationIteration, setAnimationIteration] = useState(0);
  const windowDimensions = useWindowSize();
  const {
    geoLocation
  } = useGeoSearch();
  const [isMapVisible, setIsMapVisible] = useLocalStorage<boolean>("mapVisible", initiallyOpen);
  useEffect(() => {
    setHasMounted(true);
  }, []);
  useEffect(() => {
    if (animationIteration > 4) {
      setShowMapAnimation(false);
      setAnimationIteration(0);
    }
  }, [animationIteration]);
  useEffect(() => {
    if (geoLocation && !isMapVisible) {
      setShowMapAnimation(true);
    }
    // NOTE: Only run when geoLocation changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [geoLocation, isMapVisible]);

  //This adds a bouncing css animation to the map button whenever the location is set
  //or changed and the map is not visible
  const onAnimationIteration = () => {
    setAnimationIteration(animationIteration + 1);
  };
  const toggleMap = () => {
    const isMobile = windowDimensions && windowDimensions.width < 768;
    const scrollID = isMobile ? "jobMapWrapper" : "filterbar";
    const element = document.getElementById(scrollID);
    if (element && !isMapVisible) {
      const y = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: y,
        behavior: "smooth"
      });
    }
    setIsMapVisible(!isMapVisible);
  };
  return {
    hasMounted,
    isMapVisible,
    toggleMap,
    showMapAnimation,
    onAnimationIteration
  };
}